import type { ColDef, ValueFormatterParams } from "ag-grid-enterprise";
import { read, utils } from "xlsx";

export interface SheetData {
  name: string;
  rows: Record<string, unknown>[];
  columns: ColDef[];
}

const isXlsx = (filename?: string) => /\.xlsx?$/i.test(filename ?? "");

const dateFormatter = (params: ValueFormatterParams) => {
  if (params.value instanceof Date) {
    return params.value.toLocaleDateString();
  }
  return params.value;
};

export const parseSpreadsheet = (
  arrayBuffer: ArrayBuffer,
  filename?: string,
): SheetData[] => {
  const useExcelDates = isXlsx(filename);
  const workbook = read(arrayBuffer, {
    type: "array",
    ...(useExcelDates ? { cellDates: true } : { raw: true }),
  });

  return workbook.SheetNames.map((sheetName) => {
    const worksheet = workbook.Sheets[sheetName]!;
    const headers =
      utils.sheet_to_json<string[]>(worksheet, {
        header: 1,
      })[0] ?? [];

    const jsonData = utils.sheet_to_json<Record<string, unknown>>(worksheet, {
      defval: "",
      ...(useExcelDates ? { raw: true } : {}),
    });

    const columns: ColDef[] = headers
      .filter((header) => header != null && header !== "")
      .map((header) => ({
        field: String(header),
        headerName: String(header),
        minWidth: 120,
        resizable: true,
        sortable: true,
        filter: true,
        ...(useExcelDates ? { valueFormatter: dateFormatter } : {}),
      }));

    return { name: sheetName, rows: jsonData, columns };
  });
};
